import { render, staticRenderFns } from "./BookingnoFlightDetails.vue?vue&type=template&id=bf3ef4f0&scoped=true"
import script from "./BookingnoFlightDetails.vue?vue&type=script&lang=js"
export * from "./BookingnoFlightDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingnoFlightDetails.vue?vue&type=style&index=0&id=bf3ef4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3ef4f0",
  null
  
)

export default component.exports